<template>
  <div class="home-box flex flex-d ai-c">
    <div class="content flex flex-d" v-for="(item,index) in versionList" :key="index">
      <div class="contentTitle flex jc-sb ai-c">
        <div class="version flex ai-c" v-if="isIos">
          <i class="point"></i>
          v{{ item.iosVersionNum }}
        </div>
        <div class="version flex ai-c" v-else>
          <i class="point"></i>
          v{{ item.versionNum }}
        </div>
        <div class="time">{{ item.time }}</div>
      </div>
      <div class="main" v-html="item.versionDescribe"></div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: 'carrousel',
  data() {
    return {
      versionList: [],//版本列表
      isIos: false
    }
  },
  components: {},
  mounted () {
    var u = navigator.userAgent;
    this.isIos = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    this.getData();
  },
  computed: {},
  methods: {
    getData(){
      // let url = "http://58.18.32.146:17017/version/versionHistory";
      let url = "http://m.synlen.com/version/versionHistory";
      axios.get(url).then(res => {
        if(res&&res.data&&res.data.body&&res.data.body.length!=0){
          this.versionList = res.data.body;
        }else{
          this.versionList = [];
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/styles/common.scss";
.home-box {
  width: 100%;
  height: 100vh;
  padding: 0 20px 20px;
  box-sizing: border-box;
  overflow-y: scroll;
  overflow-x: hidden;
  font-family: 'Source Han Sans CN';
  background-color: #f6f6f6;
  .content{
    width: 100%;
    padding: 20px 20px;
    box-sizing: border-box;
    background-color: #fff;
    border-radius: 10px;
    margin: 20px 0 0;
    .contentTitle{
      .version{
        font-size: 30px;
        font-family: SourceHanSansCN-Medium, SourceHanSansCN;
        font-weight: 500;
        color: #333333;
        .point{
          width: 10px;
          height: 10px;
          border-radius: 50%;
          background-color: #1F95E2;
          margin-right: 10px;
        }
      }
      .time{
        font-size: 22px;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #999999;
      }
    }
    .main{
      font-size: 24px;
      font-family: SourceHanSansCN-Regular, SourceHanSansCN;
      font-weight: 400;
      color: #333333;
      text-align: left;
      padding: 20px 20px 0;
    }
  }
}
</style>